import Request from '@/api/request';
import { ISelectRoleRequest } from '@/types/auth';
import { UserEntity } from '@/domains/User';
import { GET_AUTHORIZATION_CODE_URL, LOGOUT_URL } from '@/constants';

const api = new Request();

export function getAuthorizationCode(): Promise<any> {
  return api.get(GET_AUTHORIZATION_CODE_URL);
}

export function logout(): Promise<any> {
  return api.get(LOGOUT_URL);
}

export function getResource(): Promise<UserEntity> {
  return api.get('lk/auth/getResource');
}

export function selectRole(query: ISelectRoleRequest): Promise<any> {
  let queryString = '';
  for (const key in query) {
    // @ts-ignore
    queryString += `&${key}=${query[key]}`;
  }
  queryString = queryString.slice(1);
  return api.post(`lk/auth/selectRole/?${queryString}`);
}
